export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;
export const ADDRESSING_CODE_REGEX = /^\d{9}(\d{5})?([-_/][A-Za-z0-9._-]+)?$/;
export const phoneNumberRegex = /^((\+)33|0|0033)[1-9](\d{2}){4}$/;
